package com.milta.di

import com.milta.core.appconfig.AppConfigApi
import com.milta.core.appconfig.AppConfigRepository
import com.milta.core.appconfig.AppConfigRepositoryImpl
import com.milta.core.auth.SessionManager
import com.milta.core.auth.TokenStorage
import com.milta.core.cache.LocalCacheStore
import com.milta.feature.route.presentation.RouteDraftStore
import com.milta.core.mode.AppModeManager
import com.milta.core.network.RouteRealtimeClient
import com.milta.core.network.buildHttpClient
import com.milta.feature.admin.data.remote.AdminApi
import com.milta.feature.admin.data.repository.AdminRepositoryImpl
import com.milta.feature.admin.domain.repository.AdminRepository
import com.milta.feature.admin.domain.usecase.GetAdminAccountsUseCase
import com.milta.feature.admin.domain.usecase.GetAdminClaudeUsageEventsUseCase
import com.milta.feature.admin.domain.usecase.GetAdminClaudeUsageUseCase
import com.milta.feature.admin.domain.usecase.GetAdminOcrAnalysisUseCase
import com.milta.feature.admin.domain.usecase.GetAdminPromptsUseCase
import com.milta.feature.admin.domain.usecase.ResetPromptUseCase
import com.milta.feature.admin.domain.usecase.UpdatePromptUseCase
import com.milta.feature.optimizationquota.data.remote.OptimizationQuotaApi
import com.milta.feature.optimizationquota.data.repository.OptimizationQuotaRepositoryImpl
import com.milta.feature.optimizationquota.domain.repository.OptimizationQuotaRepository
import com.milta.feature.optimizationquota.domain.usecase.GetAccountOptimizationHistoryUseCase
import com.milta.feature.optimizationquota.domain.usecase.GetAccountOptimizationQuotaUseCase
import com.milta.feature.optimizationquota.domain.usecase.GetMyOptimizationHistoryUseCase
import com.milta.feature.optimizationquota.domain.usecase.GetMyOptimizationQuotaUseCase
import com.milta.feature.optimizationquota.domain.usecase.GetOptimizationLimitsUseCase
import com.milta.feature.optimizationquota.domain.usecase.ReplaceRemainingOptimizationsUseCase
import com.milta.feature.optimizationquota.domain.usecase.UpdateOptimizationLimitsUseCase
import com.milta.feature.optimizationquota.presentation.OptimizationQuotaStore
import com.milta.feature.aicredit.data.remote.AiCreditApi
import com.milta.feature.aicredit.data.repository.AiCreditRepositoryImpl
import com.milta.feature.aicredit.domain.repository.AiCreditRepository
import com.milta.feature.aicredit.domain.usecase.GetAccountAiCreditHistoryUseCase
import com.milta.feature.aicredit.domain.usecase.GetAccountAiCreditUseCase
import com.milta.feature.aicredit.domain.usecase.GetAiCreditSettingsUseCase
import com.milta.feature.aicredit.domain.usecase.GetMyAiCreditHistoryUseCase
import com.milta.feature.aicredit.domain.usecase.GetMyAiCreditUseCase
import com.milta.feature.aicredit.domain.usecase.ReplaceRemainingAiCreditUseCase
import com.milta.feature.aicredit.domain.usecase.UpdateAiCreditSettingsUseCase
import com.milta.feature.aicredit.presentation.AiCreditStore
import com.milta.feature.auth.data.remote.AuthApi
import com.milta.feature.auth.data.repository.AuthRepositoryImpl
import com.milta.feature.auth.domain.repository.AuthRepository
import com.milta.feature.delivery.data.remote.DeliveryApi
import com.milta.feature.delivery.data.repository.DeliveryRepositoryImpl
import com.milta.feature.delivery.domain.repository.DeliveryRepository
import com.milta.feature.delivery.domain.usecase.CreateDeliveryUseCase
import com.milta.feature.delivery.domain.usecase.ValidateAddressUseCase
import com.milta.feature.importjobs.data.remote.ImportJobsApi
import com.milta.feature.importjobs.data.repository.ImportJobRepositoryImpl
import com.milta.feature.importjobs.domain.repository.ImportJobRepository
import com.milta.feature.importjobs.domain.usecase.AcknowledgeImportJobUseCase
import com.milta.feature.importjobs.domain.usecase.CancelImportJobUseCase
import com.milta.feature.importjobs.domain.usecase.GetImportJobUseCase
import com.milta.feature.importjobs.domain.usecase.ListActiveImportJobsUseCase
import com.milta.feature.importjobs.domain.usecase.RetryImportJobUseCase
import com.milta.feature.importjobs.domain.usecase.SubmitImportJobUseCase
import com.milta.feature.importjobs.presentation.ImportJobTracker
import com.milta.feature.imports.data.remote.ImportPdfApi
import com.milta.feature.imports.data.repository.ImportPdfRepositoryImpl
import com.milta.feature.imports.domain.repository.ImportPdfRepository
import com.milta.feature.imports.domain.usecase.ExtractDeliveriesFromPdfUseCase
import com.milta.feature.legal.data.remote.LegalDocumentApi
import com.milta.feature.legal.data.repository.LegalDocumentRepositoryImpl
import com.milta.feature.legal.domain.repository.LegalDocumentRepository
import com.milta.feature.legal.domain.usecase.GetLegalDocumentUseCase
import com.milta.feature.ocrscan.data.remote.OcrScanApi
import com.milta.feature.ocrscan.data.repository.OcrScanRepositoryImpl
import com.milta.feature.ocrscan.domain.repository.OcrScanRepository
import com.milta.feature.ocrscan.domain.usecase.ScanDeliveryPhotoUseCase
import com.milta.feature.profile.data.remote.ProfileApi
import com.milta.feature.profile.data.repository.DriverEnterprisesRepositoryImpl
import com.milta.feature.profile.data.repository.ProfileRepositoryImpl
import com.milta.feature.profile.domain.repository.ProfileRepository
import com.milta.feature.profile.domain.usecase.ConfirmAccountDeletionUseCase
import com.milta.feature.profile.domain.usecase.ConfirmPhoneChangeUseCase
import com.milta.feature.profile.domain.repository.DriverEnterprisesRepository
import com.milta.feature.profile.domain.usecase.GetMyDriverLinkCodeUseCase
import com.milta.feature.profile.domain.usecase.GetMyEnterprisesUseCase
import com.milta.feature.profile.domain.usecase.GetProfileUseCase
import com.milta.feature.profile.domain.usecase.RequestAccountDeletionUseCase
import com.milta.feature.profile.domain.usecase.RequestPhoneChangeUseCase
import com.milta.feature.profile.domain.usecase.UpdateLanguageUseCase
import com.milta.feature.route.data.local.PendingDeliveryValidationLocalDataSource
import com.milta.feature.route.data.remote.LoadingAddressApi
import com.milta.feature.route.data.remote.RouteApi
import com.milta.feature.route.data.repository.LoadingAddressRepositoryImpl
import com.milta.feature.route.data.repository.OfflineSyncRepositoryImpl
import com.milta.feature.route.data.repository.RouteRepositoryImpl
import com.milta.feature.route.domain.repository.LoadingAddressRepository
import com.milta.feature.route.domain.repository.OfflineSyncRepository
import com.milta.feature.route.domain.repository.RouteRepository
import com.milta.feature.route.domain.usecase.AddDeliveriesToRouteUseCase
import com.milta.feature.route.domain.usecase.AddLoadingAddressUseCase
import com.milta.feature.route.domain.usecase.DeleteLoadingAddressUseCase
import com.milta.feature.route.domain.usecase.GetLoadingAddressesUseCase
import com.milta.feature.route.domain.usecase.CompleteRouteUseCase
import com.milta.feature.route.domain.usecase.CreateOwnRouteUseCase
import com.milta.feature.route.domain.usecase.CreateRouteBatchUseCase
import com.milta.feature.route.domain.usecase.CreateRouteUseCase
import com.milta.feature.route.domain.usecase.DeleteRouteUseCase
import com.milta.feature.route.domain.usecase.DeleteRouteBatchUseCase
import com.milta.feature.route.domain.usecase.DispatchRouteBatchUseCase
import com.milta.feature.route.domain.usecase.DispatchRouteUseCase
import com.milta.feature.route.domain.usecase.GetMyRouteUseCase
import com.milta.feature.route.domain.usecase.GetMyRoutesUseCase
import com.milta.feature.route.domain.usecase.GetRouteDetailUseCase
import com.milta.feature.route.domain.usecase.GetRouteHistoryUseCase
import com.milta.feature.route.domain.usecase.GetRouteProofsUseCase
import com.milta.feature.route.domain.usecase.GetTeamRoutesOverviewUseCase
import com.milta.feature.route.domain.usecase.ImportRouteFileUseCase
import com.milta.feature.route.domain.usecase.OptimizeRouteUseCase
import com.milta.feature.route.domain.usecase.RegeocodeRouteUseCase
import com.milta.feature.route.domain.usecase.UpdateDeliveryAddressUseCase
import com.milta.feature.route.domain.usecase.RemoveDeliveryFromRouteUseCase
import com.milta.feature.route.domain.usecase.ReoptimizeInPlaceUseCase
import com.milta.feature.route.domain.usecase.ReoptimizeRouteBatchUseCase
import com.milta.feature.route.domain.usecase.StartRouteUseCase
import com.milta.feature.route.domain.usecase.ValidateDeliveryUseCase
import com.milta.feature.team.data.remote.TeamApi
import com.milta.feature.team.data.repository.TeamRepositoryImpl
import com.milta.feature.team.domain.repository.TeamRepository
import com.milta.feature.team.domain.usecase.DeleteEnterpriseUseCase
import com.milta.feature.team.domain.usecase.GetEnterpriseDriversUseCase
import com.milta.feature.team.domain.usecase.GetMyEnterpriseUseCase
import com.milta.feature.team.domain.usecase.GetMyTeamUseCase
import com.milta.feature.team.domain.usecase.LinkDriverUseCase
import com.milta.feature.team.domain.usecase.RemoveDriverUseCase
import com.milta.feature.subscription.data.remote.SubscriptionApi
import com.milta.feature.subscription.data.repository.SubscriptionAccessRepositoryImpl
import com.milta.feature.subscription.data.repository.SubscriptionRepositoryImpl
import com.milta.feature.subscription.domain.repository.SubscriptionRepository
import com.milta.feature.subscription.domain.repository.SubscriptionAccessRepository
import com.milta.feature.subscription.domain.usecase.CheckSubscriptionAccessUseCase
import com.milta.feature.subscription.domain.usecase.GetMySubscriptionUseCase
import com.milta.feature.subscription.domain.usecase.GetSubscriptionPlansUseCase
import com.milta.feature.subscription.domain.usecase.SubmitReceiptUseCase
import com.milta.feature.spreadsheetimport.data.remote.SpreadsheetImportApi
import com.milta.feature.spreadsheetimport.data.repository.SpreadsheetImportRepositoryImpl
import com.milta.feature.spreadsheetimport.domain.repository.SpreadsheetImportRepository
import com.milta.feature.spreadsheetimport.domain.usecase.ImportSpreadsheetUseCase
import org.koin.core.qualifier.named
import org.koin.dsl.module

val authModule = module {
    single { SessionManager() }
    single<AuthRepository> { AuthRepositoryImpl(get(), get(), get(), get(), get(), get()) }
}

val modeModule = module {
    single { AppModeManager(get()) }
}

// Ad hoc feature (2026-08) — RoutaR kill switch, shared by mobile and webApp (see AppConfigRepositoryImpl).
val appConfigModule = module {
    single<AppConfigRepository> { AppConfigRepositoryImpl(get()) }
}

val profileModule = module {
    single<ProfileRepository> { ProfileRepositoryImpl(get(), get()) }
    factory { GetProfileUseCase(get()) }
    factory { UpdateLanguageUseCase(get()) }
    factory { RequestPhoneChangeUseCase(get()) }
    factory { ConfirmPhoneChangeUseCase(get()) }
    factory { RequestAccountDeletionUseCase(get()) }
    factory { ConfirmAccountDeletionUseCase(get()) }
    factory { GetMyDriverLinkCodeUseCase(get()) }
    single<DriverEnterprisesRepository> { DriverEnterprisesRepositoryImpl(get()) }
    factory { GetMyEnterprisesUseCase(get()) }
}

val subscriptionModule = module {
    single<SubscriptionRepository> { SubscriptionRepositoryImpl(get(), get()) }
    factory { GetMySubscriptionUseCase(get()) }
    factory { SubmitReceiptUseCase(get()) }
    factory { GetSubscriptionPlansUseCase(get()) }
    single<SubscriptionAccessRepository> { SubscriptionAccessRepositoryImpl(get()) }
    factory { CheckSubscriptionAccessUseCase(get()) }
    // MIL-18 Phase 3: PurchaseClient is platform-specific (real BillingManager on Android via
    // billing-ktx, no StoreKit implementation on iOS yet) — bound in each platform's own module
    // (see androidModule), not here, to avoid a definition conflict. SubscriptionScreen is the
    // only caller and is never composed on the web target, so jsModule doesn't need one either.
}

// NOTE (MIL-35/screen unification): DeliveryRepository is still used for address autocomplete by
// DeliveryEntrySheet (feature.route.presentation) — CreateDeliveryUseCase itself (the retired
// two-step CreateDelivery + Optimize flow) has no caller left. Left registered (unused) rather than
// deleting the whole feature.delivery package, which is outside this ticket's scope.
val deliveryModule = module {
    single<DeliveryRepository> { DeliveryRepositoryImpl(get()) }
    factory { CreateDeliveryUseCase(get()) }
    factory { ValidateAddressUseCase(get()) }
}

val routeModule = module {
    single<RouteRepository> { RouteRepositoryImpl(get(), get()) }
    factory { GetMyRouteUseCase(get()) }
    factory { GetMyRoutesUseCase(get()) }
    factory { CreateOwnRouteUseCase(get()) }
    factory { StartRouteUseCase(get()) }
    factory { CompleteRouteUseCase(get()) }
    factory { ReoptimizeInPlaceUseCase(get()) }
    factory { CreateRouteUseCase(get()) }
    factory { ImportRouteFileUseCase(get()) }
    factory { OptimizeRouteUseCase(get()) }
    factory { DispatchRouteUseCase(get()) }
    factory { AddDeliveriesToRouteUseCase(get()) }
    // MIL-38 — Manager team dashboard + route detail (Enterprise view)
    factory { GetTeamRoutesOverviewUseCase(get()) }
    factory { GetRouteDetailUseCase(get()) }
    // MIL-52 — "Historique des preuves de livraison" (Screen A history list + Screen B proofs grid)
    factory { GetRouteHistoryUseCase(get()) }
    factory { GetRouteProofsUseCase(get()) }
    // MIL-45 — manual re-geocode from the route detail screen
    factory { RegeocodeRouteUseCase(get()) }
    // MIL-99 — the route's creator corrects an unlocated stop before sending/start
    factory { UpdateDeliveryAddressUseCase(get()) }
    single { RouteRealtimeClient(get()) }
    factory { RemoveDeliveryFromRouteUseCase(get()) }
    // MIL-65 — delete a not-yet-started route from the Accueil Livreur screen
    factory { DeleteRouteUseCase(get()) }
    // MIL-39 — multi-driver batch dispatch
    factory { CreateRouteBatchUseCase(get()) }
    factory { ReoptimizeRouteBatchUseCase(get()) }
    factory { DispatchRouteBatchUseCase(get()) }
    factory { DeleteRouteBatchUseCase(get()) }
    // MIL-99 — Enterprise's saved loading addresses (Créer une tournée mobile + web)
    single<LoadingAddressRepository> { LoadingAddressRepositoryImpl(get()) }
    factory { GetLoadingAddressesUseCase(get()) }
    factory { AddLoadingAddressUseCase(get()) }
    factory { DeleteLoadingAddressUseCase(get()) }
    // MIL-41 — proof of delivery (photo + status + comment)
    factory { ValidateDeliveryUseCase(get()) }
}

// MIL-43 — offline validation queue, persisted via LocalCacheStore (mode hors ligne). `single`
// shared by every screen rather than recreated per-screen, so the in-memory StateFlow stays
// consistent across navigation even though the source of truth is now on disk.
val offlineSyncModule = module {
    single { PendingDeliveryValidationLocalDataSource(get()) }
    single<OfflineSyncRepository> { OfflineSyncRepositoryImpl(get(), get()) }
}

val importsModule = module {
    // MIL-26 — POST /imports/pdf, distinct endpoint/contract from the MIL-29 flow above.
    single<ImportPdfRepository> { ImportPdfRepositoryImpl(get()) }
    factory { ExtractDeliveriesFromPdfUseCase(get()) }
}

// Imports asynchrones — `/import-jobs`. The tracker is created eagerly at startKoin (one instance
// per app, alive for the whole process) so it follows the session and the running import
// whatever screen is shown, without any screen having to instantiate it.
val importJobsModule = module {
    single<ImportJobRepository> { ImportJobRepositoryImpl(get()) }
    factory { SubmitImportJobUseCase(get()) }
    factory { GetImportJobUseCase(get()) }
    factory { ListActiveImportJobsUseCase(get()) }
    factory { RetryImportJobUseCase(get()) }
    factory { CancelImportJobUseCase(get()) }
    factory { AcknowledgeImportJobUseCase(get()) }
    single(createdAtStart = true) {
        ImportJobTracker(
            submitImportJob = get(),
            getImportJob = get(),
            listActiveImportJobs = get(),
            retryImportJob = get(),
            cancelImportJob = get(),
            acknowledgeImportJob = get(),
            authRepository = get(),
            connectivityObserver = get(),
            localCacheStore = get(),
        )
    }
}

val ocrScanModule = module {
    single<OcrScanRepository> { OcrScanRepositoryImpl(get()) }
    factory { ScanDeliveryPhotoUseCase(get()) }
}

val spreadsheetImportModule = module {
    single<SpreadsheetImportRepository> { SpreadsheetImportRepositoryImpl(get()) }
    factory { ImportSpreadsheetUseCase(get()) }
}

/** Qualifier of the [GetLegalDocumentUseCase] used by the public web pages (`/privacy`, `/terms`). */
const val PUBLIC_LEGAL_DOCUMENTS = "publicLegalDocuments"

val legalModule = module {
    single<LegalDocumentRepository> { LegalDocumentRepositoryImpl(get()) }
    factory { GetLegalDocumentUseCase(get()) }
    // Anonymous client (no Auth plugin): pages shown without signing in never send a bearer token,
    // so no 401 → refresh → SessionExpired chain can start from them, even with stale stored tokens.
    single(named(PUBLIC_LEGAL_DOCUMENTS)) {
        GetLegalDocumentUseCase(LegalDocumentRepositoryImpl(LegalDocumentApi(buildHttpClient())))
    }
}

val teamModule = module {
    single<TeamRepository> { TeamRepositoryImpl(get(), get()) }
    factory { GetMyTeamUseCase(get()) }
    factory { GetEnterpriseDriversUseCase(get()) }
    factory { LinkDriverUseCase(get()) }
    factory { RemoveDriverUseCase(get()) }
    // MIL-53 — Dashboard Web "Paramètres"
    factory { GetMyEnterpriseUseCase(get()) }
    factory { DeleteEnterpriseUseCase(get()) }
}

// Dashboard Web "Utilisateurs" (Admin, 2026-10-03) — read-only, cross-tenant, web-only.
val adminModule = module {
    single<AdminRepository> { AdminRepositoryImpl(get()) }
    factory { GetAdminAccountsUseCase(get()) }
    factory { GetAdminPromptsUseCase(get()) }
    factory { UpdatePromptUseCase(get()) }
    factory { ResetPromptUseCase(get()) }
    factory { GetAdminOcrAnalysisUseCase(get()) }
    factory { GetAdminClaudeUsageUseCase(get()) }
    factory { GetAdminClaudeUsageEventsUseCase(get()) }
}

// MIL-97 — RoutaR optimization counter per account. The store is a `single`: every screen showing
// an optimization button reads the same value and refreshes it after each optimization.
val optimizationQuotaModule = module {
    single<OptimizationQuotaRepository> { OptimizationQuotaRepositoryImpl(get()) }
    factory { GetMyOptimizationQuotaUseCase(get()) }
    factory { GetMyOptimizationHistoryUseCase(get()) }
    factory { GetOptimizationLimitsUseCase(get()) }
    factory { UpdateOptimizationLimitsUseCase(get()) }
    factory { GetAccountOptimizationQuotaUseCase(get()) }
    factory { GetAccountOptimizationHistoryUseCase(get()) }
    factory { ReplaceRemainingOptimizationsUseCase(get()) }
    single { OptimizationQuotaStore(get()) }
}

// MIL-98 — AI credit per account. Same shape as the MIL-97 counter: one `single` store read by
// every screen showing an AI action, refreshed when it opens and after each AI action.
val aiCreditModule = module {
    single { AiCreditApi(get()) }
    single<AiCreditRepository> { AiCreditRepositoryImpl(get()) }
    factory { GetMyAiCreditUseCase(get()) }
    factory { GetMyAiCreditHistoryUseCase(get()) }
    factory { GetAiCreditSettingsUseCase(get()) }
    factory { UpdateAiCreditSettingsUseCase(get()) }
    factory { GetAccountAiCreditUseCase(get()) }
    factory { GetAccountAiCreditHistoryUseCase(get()) }
    factory { ReplaceRemainingAiCreditUseCase(get()) }
    single { AiCreditStore(get()) }
    // Retour 28/10 (brouillon, option C) — "Nouvelle tournée" / "Créer ma tournée" kept on disk.
    single { RouteDraftStore(get<LocalCacheStore>(), get<TokenStorage>()) }
}

val networkModule = module {
    single { buildHttpClient(get(), get()) }
    single { AuthApi(get()) }
    single { AppConfigApi(get()) }
    single { ProfileApi(get()) }
    single { SubscriptionApi(get()) }
    single { DeliveryApi(get()) }
    single { RouteApi(get()) }
    single { LoadingAddressApi(get()) }
    single { TeamApi(get()) }
    single { ImportPdfApi(get()) }
    single { ImportJobsApi(get()) }
    single { OcrScanApi(get()) }
    single { SpreadsheetImportApi(get()) }
    single { LegalDocumentApi(get()) }
    single { AdminApi(get()) }
    single { OptimizationQuotaApi(get()) }
}
